<!-- Header con gradiente -->
<div style="background: linear-gradient(135deg, #f0fdf4, #ecfdf5); padding: 20px 24px; border-bottom: 2px solid #bbf7d0;">
  <div class="flex items-center justify-between">
    <div class="flex items-center gap-3">
      <mat-icon style="color: #1C593D; font-size: 28px; width: 28px; height: 28px;">history</mat-icon>
      <div>
        <h2 style="margin: 0; font-size: 1.25rem; font-weight: 800; color: #1e5a3f;">
          Historial de Transacciones
        </h2>
        <span class="font-mono font-bold bg-green-100 text-green-800 px-2 py-0.5 rounded-full text-xs">
          Orden #{{ data.id }}
        </span>
      </div>
    </div>
    <button title="Exportar a Excel" (click)="printHistorial()"
      style="display: inline-flex; align-items: center; gap: 6px; padding: 8px 16px; background: white; color: #1C593D; border: 1px solid #bbf7d0; border-radius: 8px; cursor: pointer; font-size: 0.8rem; font-weight: 600; transition: all 0.2s ease;"
      onmouseover="this.style.background='#f0fdf4'"
      onmouseout="this.style.background='white'">
      <mat-icon style="font-size: 16px; width: 16px; height: 16px; color: #1C593D;">download</mat-icon>
      Excel
    </button>
  </div>
</div>

<!-- Body -->
<div style="padding: 16px 24px;">

  <!-- Paginator -->
  <div class="flex justify-center mb-3">
    <mat-paginator #paginator
      class="demo-paginator"
      (page)="onPageChange($event)"
      [length]="totalItems"
      [pageSize]="pageSize"
      [disabled]="false"
      [showFirstLastButtons]="true"
      [pageSizeOptions]="[5, 10, 25, 50, 100]"
      [hidePageSize]="false"
      [pageIndex]="currentPage - 1"
      aria-label="Select page">
    </mat-paginator>
  </div>

  <!-- Desktop Table -->
  <div class="hidden md:block overflow-x-auto rounded-xl shadow-lg border border-gray-100 max-h-[400px] overflow-y-auto" *ngIf="dataSource">
    <table mat-table [dataSource]="dataSource" matSort class="w-full">

      <ng-container matColumnDef="idTransferencia">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>ID</th>
        <td mat-cell *matCellDef="let row">
          <span class="font-mono font-bold bg-green-100 text-green-800 px-2 py-0.5 rounded-full text-xs">
            #{{ row.idTransferencia }}
          </span>
        </td>
      </ng-container>

      <ng-container matColumnDef="fechaInicio">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>F. Inicio</th>
        <td mat-cell *matCellDef="let row" class="text-xs" style="color: #374151;">
          {{ formatDate(row.fechaInicio) }}
        </td>
      </ng-container>

      <ng-container matColumnDef="fechaFondeoWallet">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>F. Fondeo</th>
        <td mat-cell *matCellDef="let row" class="text-xs" style="color: #374151;">
          {{ formatDate(row.fechaFondeoWallet) }}
        </td>
      </ng-container>

      <ng-container matColumnDef="montoCLP">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>Monto CLP</th>
        <td mat-cell *matCellDef="let row" class="text-xs font-bold" style="color: #1e5a3f;">
          {{ row.montoCLP | currency:'$' }}
        </td>
      </ng-container>

      <ng-container matColumnDef="montoUSDT">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>Monto USDT</th>
        <td mat-cell *matCellDef="let row" class="text-xs font-bold" style="color: #1e5a3f;">
          {{ row.montoUSDT | currency:'$' }}
        </td>
      </ng-container>

      <ng-container matColumnDef="remitente">
        <th mat-header-cell *matHeaderCellDef>Remitente</th>
        <td mat-cell *matCellDef="let row" class="text-xs font-semibold" style="color: #374151;">
          {{ row.remitente }}
        </td>
      </ng-container>

      <ng-container matColumnDef="estadoActual">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>Estado</th>
        <td mat-cell *matCellDef="let row">
          <span class="px-2 py-1 inline-flex text-xs leading-5 font-bold rounded-full"
            [style.background]="getStatusBg(row)"
            [style.color]="getStatusColor(row)">
            {{ row.estadoActual.replace('_', ' ') }}
          </span>
        </td>
      </ng-container>

      <ng-container matColumnDef="tn">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>Tasa</th>
        <td mat-cell *matCellDef="let row" class="text-xs font-bold" style="color: #7c3aed;">
          {{ row.tn }}
        </td>
      </ng-container>

      <ng-container matColumnDef="walletTRC20">
        <th mat-header-cell *matHeaderCellDef>Wallet</th>
        <td mat-cell *matCellDef="let row" class="text-xs font-mono" style="color: #2563eb; max-width: 150px; overflow: hidden; text-overflow: ellipsis; white-space: nowrap;">
          {{ row.walletTRC20 }}
        </td>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
      <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
    </table>
  </div>

  <!-- Mobile Cards -->
  <div class="md:hidden space-y-3" *ngIf="dataSource">
    <div *ngFor="let row of dataSource.data"
      class="bg-white rounded-xl shadow-md border border-gray-200 p-4">
      <div class="flex flex-col gap-2 mb-3">
        <div class="flex items-center justify-between">
          <span style="color: #6b7280; font-size: 0.7rem; font-weight: 600;">ID Transferencia</span>
          <span class="px-2 py-0.5 inline-flex text-xs leading-5 font-bold rounded-full"
            [style.background]="getStatusBg(row)"
            [style.color]="getStatusColor(row)">
            {{ row.estadoActual.replace('_', ' ') }}
          </span>
        </div>
        <span class="font-mono font-bold bg-green-100 text-green-800 px-2 py-1 rounded-lg text-xs break-all" style="display: block;">
          #{{ row.idTransferencia }}
        </span>
      </div>
      <div class="grid grid-cols-2 gap-2 text-xs">
        <div>
          <span style="color: #6b7280; font-weight: 600;">Remitente</span>
          <p class="font-semibold" style="color: #374151;">{{ row.remitente }}</p>
        </div>
        <div>
          <span style="color: #6b7280; font-weight: 600;">Tasa</span>
          <p class="font-bold" style="color: #7c3aed;">{{ row.tn }}</p>
        </div>
        <div>
          <span style="color: #6b7280; font-weight: 600;">Monto CLP</span>
          <p class="font-bold" style="color: #1e5a3f;">{{ row.montoCLP | currency:'$' }}</p>
        </div>
        <div>
          <span style="color: #6b7280; font-weight: 600;">Monto USDT</span>
          <p class="font-bold" style="color: #1e5a3f;">{{ row.montoUSDT | currency:'$' }}</p>
        </div>
        <div>
          <span style="color: #6b7280; font-weight: 600;">F. Inicio</span>
          <p style="color: #374151; font-weight: 500;">{{ formatDate(row.fechaInicio) }}</p>
        </div>
        <div>
          <span style="color: #6b7280; font-weight: 600;">F. Fondeo</span>
          <p style="color: #374151; font-weight: 500;">{{ formatDate(row.fechaFondeoWallet) }}</p>
        </div>
        <div class="col-span-2">
          <span style="color: #6b7280; font-weight: 600;">Wallet</span>
          <p class="font-mono text-xs break-all" style="color: #2563eb;">{{ row.walletTRC20 }}</p>
        </div>
      </div>
    </div>
  </div>
</div>
